export default theme => ({
  toggleContainer: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    margin: `${theme.spacing.unit}px 0`
  }
});
